module.exports = __webpack_public_path__ + "assets/img/icon-hint-finger.64b8b66d.png";